import PhoneFieldWrapper from './PhoneFieldWrapper.component';

export default PhoneFieldWrapper;
